import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './mobile/mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageProvider';
import {initializeAuth} from "./amplify-config";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initializeAuth().then(() => root.render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>
));

reportWebVitals();
